//@flow
export const alertConstants = {
  SUCCESS: 'ALERT_SUCCESS',
  SUCCESS_INFO: 'ALERT_SUCCESS_INFO',
  ERROR: 'ALERT_ERROR',
  CLEAR: 'ALERT_CLEAR',
  SERVER_ERROR: 'ALERT_SERVER_ERROR'
};
